<div class="chart-container">
	<h3>{{ title() }}</h3>
	@if (hasValue()) {
	<div class="chart-wrapper">
		<canvas [id]="chartId()"></canvas>
	</div>
	<div class="chart-legend">
		<span class="chart-legend-item">
			<i class="material-icons" [style]="{'color': COLOR2}">stop</i>
			{{ label2() }}
		</span>
		<span class="chart-legend-item ms-5">
			<i class="material-icons" [style]="{'color': COLOR1}">stop</i>
			{{ label1() }}
		</span>
	</div>
	} @else {
	<span class="chart-empty">0</span>
	}
</div>